import { Link, useLocation } from "@tanstack/react-router";
import {
	BookOpen,
	// BookOpenText,
	BookPlus,
	// FilePlus,
	History,
	Home,
	MessageCircle,
} from "lucide-react";

import { cn } from "@/lib/utils";

const menu = [
	{
		label: "홈",
		icon: <Home />,
		path: "/",
	},
	{
		label: "전체 설명서",
		icon: <BookOpen />,
		path: "/pack",
	},
	// {
	// 	label: "내 설명서",
	// 	icon: <BookOpenText />,
	// 	path: "/deck/list",
	// },
	{
		label: "내 설명서 생성",
		icon: <BookPlus />,
		path: "/deck",
	},
	{
		label: "전송내역",
		icon: <History />,
		path: "/send",
	},
];

export const Sidebar = () => {
	const location = useLocation();

	return (
		<aside className="w-20 h-full bg-white shadow-xs flex flex-col items-center gap-10 py-6 px-2">
			<img src="/dxmt_logo_color.svg" alt="logo" className="h-5" />

			<ul className="flex flex-col gap-8 flex-1">
				{menu.map((item) => (
					<li key={item.path}>
						<Link to={item.path}>
							<div
								className={cn(
									"flex flex-col items-center gap-1 text-gray-500",
									location.pathname === item.path && "text-doxmeet",
								)}
							>
								{item.icon}
								<span className="text-sm break-keep text-center">
									{item.label}
								</span>
							</div>
						</Link>
					</li>
				))}

				<div className="flex-1" />

				<li className="justify-end">
					<Link to="/support">
						<div
							className={cn(
								"flex flex-col items-center gap-1 text-gray-500",
								location.pathname === "/support" && "text-doxmeet",
							)}
						>
							<MessageCircle />
							<span className="text-sm break-keep text-center">문의</span>
						</div>
					</Link>
				</li>
			</ul>
		</aside>
	);
};
